import React, { Fragment } from 'react'
import { Link, StaticQuery, graphql } from 'gatsby'

import Modal from '../Modal'
import Content from '../../content'
import Calendly from '../Calendly'
import { StateProvider, viewportContainer, scrollToAnchor, ModalSubscriber, modalContainer } from '../../core'

import './header.scss'

const LinkItem = ({ text, link, ...rest }) => (
  <li styleName='header-link' {...rest}>
    {link.indexOf('http') > -1
      ? <a href={link} target="_blank" rel="noopener noreferrer" {...rest}>{text}</a>
      : <Link to={link} {...rest}>{text}</Link>
    }
  </li>
)

class Header extends React.Component {
  headerRef = React.createRef()

  state = {
    forceActiveCTA: false,
  }

  componentDidMount() {
    viewportContainer.subscribe(this.handleUpdate)
    viewportContainer.setHeaderRef(this.headerRef)
  }

  componentWillUnmount() {
    this.isUnmounted = true
  }

  handleUpdate = () => {
    if (this.isUnmounted || !this.headerRef.current) return

    const footer = document.getElementsByTagName('footer')[0]
    const footerRect = footer.getBoundingClientRect()

    const shouldActivate = viewportContainer.vw < 768
      ? (footerRect.top <= this.headerRef.current.clientHeight)
      : (footerRect.top <= this.headerRef.current.clientHeight * 2)

    if (shouldActivate) {
      this.setState({ forceActiveCTA: true })
    } else {
      this.setState({ forceActiveCTA: false })
    }
  }

  render() {
    const { forceActiveCTA } = this.state

    return (
      <StaticQuery
        query={graphql`
          query {
            allContentfulSiteHeader {
              edges {
                node {
                  primaryLinks {
                    text
                    link
                  }
                  secondaryLinks {
                    text
                    link
                  }
                  mobileLinks {
                    text
                    link
                  }
                  logo {
                    file {
                      url
                    }
                  }
                  form {
                    id
                    __typename
                  }
                }
              }
            }
          }
        `}
        render={data => {
          const header = data.allContentfulSiteHeader.edges[0].node
          const logo = header.logo || { file: {} }
          const primaryLinks = header.primaryLinks || []
          const secondaryLinks = header.secondaryLinks || []
          const mobileLinks = header.mobileLinks || []

          return (
            <header styleName='header' ref={this.headerRef}>
              <div styleName='header-inner'>
                <section styleName='header-section-left' data-only="desktop">
                  <ul>
                    {primaryLinks.map((l, i) => <LinkItem key={i} {...l} />)}
                  </ul>
                </section>
    
                <section styleName='header-section-left' data-only="mobile">
                  <StateProvider>{(isActive, setActive) => (
                    <Fragment>
                      <ul>
                        {!isActive && <a styleName='mobile-link header-link' onClick={() => setActive(true)}>Menu</a>}
                        {isActive && <a onClick={() => setActive(false)} styleName='mobile-link close-modal'>✕</a>}
                      </ul>

                      <Modal 
                        isActive={isActive} 
                        onClose={() => setActive(false)}
                      >
                        <div styleName='header-overlay'>
                          <div styleName='overlay-inner'>
                            <ul>
                              {mobileLinks.map((l, i) => <LinkItem key={i} {...l} />)}
                            </ul>
                          </div>
                        </div>
                      </Modal>
                    </Fragment>
                  )}</StateProvider>
                </section>
    
                <section styleName='header-logo'>
                  <Link to="/"><img src={logo.file.url} /></Link>
                </section>
    
                <section styleName='header-section-right'>
                  <ul>
                    {secondaryLinks.map((l, i) => <LinkItem key={i} {...l} data-only="desktop" />)}
                    
                    <ModalSubscriber>{({ state }) => {
                      const isActive = state['book-a-tour'] || state['calendly'] || state['success']
                      const handleClick = () => {
                        const { pathname } = window.location
                        if (
                          pathname.indexOf('/locations/') > -1
                          && document.getElementById('book-a-tour')
                        ) {
                          scrollToAnchor('book-a-tour')
                          return
                        }
                        document.body.style.overflow = 'hidden'
                        modalContainer.open('book-a-tour')
                      }

                      const getName = () => {
                        const { hash } = window.location
                        const parts = hash.split(':')[1] || ''
                        console.log(hash, parts)
                        return parts.split('+').join(' ')
                      }
                      
                      return (
                        <Fragment>
                          <button 
                            onClick={handleClick}
                            styleName='header-cta'
                            data-is-active={isActive}
                            data-size="large"
                          >
                            Book a Tour
                          </button>
                          <div
                            styleName='header-cta-overlay-wrapper'
                            onClick={handleClick}
                          >
                            <button 
                              onClick={handleClick}
                              data-theme="noir"
                              styleName='header-cta-overlay'
                              data-is-active={forceActiveCTA}
                              data-size="large"
                            >
                            Book a Tour
                            </button>
                          </div>
      
                          <Modal 
                            isActive={isActive} 
                            onClose={() => modalContainer.close('book-a-tour')}
                            theme='Dark'
                          > 
                            {state['calendly'] && (
                              <div styleName='modal-inner'>
                                <div styleName='modal-banner'>
                                  <div styleName='modal-banner-inner'>
                                    <h1>Select a Time Below</h1>
                                  </div>
                                </div>
                                <Calendly />
                              </div>
                            )}

                            {state['book-a-tour'] && (
                              <div styleName='book-a-tour'>
                                <Content 
                                  typename={header.form.__typename} 
                                  id={header.form.id} 
                                />
                              </div>
                            )}

                            {state['success'] && (
                              <div styleName='book-a-tour'>
                                <div styleName="content ">
                                  <h2><b>Book a Tour</b></h2>
                                  <h1>Thank you for your interest, {getName()}</h1>
                                  <p>One of our Member Experience Associates will be in contact with you shortly to help better understand your needs.</p>

                                  <a href="/locations">
                                    <button><b>View All Locations</b></button>
                                  </a>
                                </div>
                              </div>
                            )}
                          </Modal>
                        </Fragment>
                      )
                    }}</ModalSubscriber>
                  </ul>
                </section>
              </div>
            </header>
          )
        }}
      />
    )
  }
}

export default Header